import { useMemo } from 'react';
import { useAuth } from 'lib/context';
import {
  checkIfAIAssistantAvailable,
  checkIfAIAssistantAvailableForCustomer,
  checkIfAIMusicAvailable,
  checkIfAIScriptsAvailable,
  checkIfAISpotlightAvailable,
  checkIfAISpotlightAvailableForCustomer,
  checkIfQuickVideosAvailable,
  checkIfSuggestedContentAvailable,
  checkIfVinReelsAvailable,
} from './utils';

export const useAIFeatureFlags = () => {
  const { userData } = useAuth();
  return useMemo(() => {
    return {
      isAIScriptsEnabled: checkIfAIScriptsAvailable(userData),
      isAIAssistantEnabled: checkIfAIAssistantAvailable(userData),
      isAIAssistantEnabledForCustomer:
        checkIfAIAssistantAvailableForCustomer(userData),
      isVinReelsEnabled: checkIfVinReelsAvailable(userData),
      isAISpotlightEnabled: checkIfAISpotlightAvailable(userData),
      isAISpotlightEnabledForCustomer:
        checkIfAISpotlightAvailableForCustomer(userData),
      isQuickVideosEnabled: checkIfQuickVideosAvailable(userData),
      isSuggestedContentEnabled: checkIfSuggestedContentAvailable(userData),
      isAIMusicEnabled: checkIfAIMusicAvailable(userData),
    };
  }, [userData]);
};
